import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import { HOME_SEO, ROUTE_SEO } from "../config/seo";

const RouteSeo = () => {
  const { pathname } = useLocation();
  const seo = ROUTE_SEO[pathname] || HOME_SEO;

  return <Seo {...seo} />;
};

export default RouteSeo;
